import React from "react";
import styles from "./GameRelatedList.module.scss";
import GameRelatedListSlider from "./GameRelatedListSlider";
import GameRelatedSearch from "./GameRelatedSearch";
import { SonicDBEntryData } from "../../common/classes/SonicDBEntry";
import { SonicTeamData } from "../../common/classes/SonicTeam";
import { SonicProjectData } from "../../common/classes/SonicProject";
import { SonicEventData } from "../../common/classes/SonicEvent";
import { SonicTopicsData } from "../../common/classes/SonicTopics";
import { SonicTermData } from "../../common/classes/SonicTerm";
import ContentCountList from "./ContentCountList";
import { getDefaultImage } from "../../utils/GeneralUtils";

type Props = {
  modalLoading: boolean;
  modalOptions: Array<SonicTermData>;
  handleSearchOption: (keyword: string) => void;
  selectedGame?: SonicTermData;
  handleSearch: (game: SonicTermData) => void;
  isLoading: boolean;
  profiles: Array<SonicDBEntryData>;
  teams: Array<SonicTeamData>;
  projects: Array<SonicProjectData>;
  events: Array<SonicEventData>;
  topics: Array<SonicTopicsData>;
  profileEntries: number;
  teamEntries: number;
  projectEntries: number;
  eventEntries: number;
  topicsEntries: number;
};
const GameRelatedList: React.FC<Props> = ({
  modalLoading,
  modalOptions,
  handleSearchOption,
  selectedGame,
  handleSearch,
  isLoading,
  profiles,
  teams,
  projects,
  events,
  topics,
  profileEntries,
  teamEntries,
  projectEntries,
  eventEntries,
  topicsEntries,
}) => {
  return (
    <main>
      <GameRelatedSearch
        modalLoading={modalLoading}
        games={modalOptions}
        selectedGame={selectedGame}
        handleSearch={handleSearch}
        handleSearchOption={handleSearchOption}
      >
        <div className={styles["container-1280"]}>
          <div className={styles["s-game-content-wrapper"]}>
            <div className={styles["c-game-head-wrapper"]}>
              <div className={styles["c-game-head"]}>
                <div className={styles["c-game-head__image"]}>
                  <img
                    src={
                      selectedGame?.img?.large?.url
                        ? selectedGame.img.large.url
                        : getDefaultImage()
                    }
                    className={styles["c-game-head__image__target"]}
                  />
                  <img
                    src={
                      selectedGame?.img?.large?.url
                        ? selectedGame.img.large.url
                        : getDefaultImage()
                    }
                    className={styles["c-game-head__image__reflect"]}
                  />
                </div>

                <ContentCountList
                  profileCount={profileEntries}
                  teamCount={teamEntries}
                  projectCount={projectEntries}
                  eventCount={eventEntries}
                  topicsCount={topicsEntries}
                />
              </div>

              <h1 className={styles["c-game-head__title"]}>
                {selectedGame?.name
                  ? selectedGame.name
                  : "ゲームが選択されていません"}
              </h1>
            </div>

            <GameRelatedListSlider
              isLoading={isLoading}
              gameTitle={selectedGame?.name}
              profiles={profiles}
              teams={teams}
              projects={projects}
              events={events}
              topics={topics}
            />
          </div>
        </div>
      </GameRelatedSearch>
    </main>
  );
};

export default GameRelatedList;
